import { useTranslations } from "next-intl";
import { PerksModal } from "../perksModal/perksModal";
import TrophyIcon from "@/components/_icons/trophyIcon";
import { TFunction } from "@/types";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
export interface PerksProps {
  handlePerksModal: () => void;
  perksModalIsOpen: boolean;
  customerPerks?: any[];
  suppressNavigationUi?: boolean;
}
export const Perks = ({
  handlePerksModal,
  perksModalIsOpen,
  customerPerks = [],
  suppressNavigationUi = false,
}: PerksProps) => {
  const t = useTranslations("Perks");
  const perksDisplayText = perksNumberDisplayText(customerPerks, t);
  return (
    <div
      data-testid={
        suppressNavigationUi
          ? undefined
          : applyDataTestId(pom.navigationBar.navigationBarPerksButton)
      }
    >
      <button
        onClick={handlePerksModal}
        className="border border-gray-300 rounded-full flex gap-2 h-[full] px-2 sm:px-6 py-2 bg-white font-sans"
      >
        <span className="flex-shrink-0 w-6 h-6">
          <TrophyIcon className="w-full h-full" />
        </span>
        <p className="lg:flex hidden">{perksDisplayText}</p>
      </button>
      <PerksModal
        isOpen={perksModalIsOpen}
        onRequestClose={handlePerksModal}
        customerPerks={customerPerks}
      />
    </div>
  );
};

const perksNumberDisplayText = (customerPerks: any, t: TFunction) => {
  const availablePerks = customerPerks?.filter(
    (perk: { available: boolean }) => perk.available
  );
  if (availablePerks.length > 1) {
    return t("multiplePerks", { count: availablePerks.length });
  } else if (availablePerks.length === 1) {
    return t("singlePerk");
  } else {
    return t("trackPerks");
  }
};
